module.exports = __webpack_public_path__ + "static/media/ic_settings.667e0425.svg";